import { atom } from "recoil";

export const requestList = atom({
  key: "requestList",
  default: [],
});